import { Pagination } from 'antd'
import Link from 'next/link'
import { useRouter } from 'next/router'
import NewsLayout from 'src/components/Layout/NewsLayout'
import PostNewsList from 'src/components/PostNewsList'
import { SEO } from 'src/components/SEO'
import BASE_CONFIG from 'src/configs/base'
import {IMAGE_HOST} from 'src/configs/API'
import commonServices from 'src/services/common.service'
import { default as newsService, default as newsServices } from 'src/services/news.service'

function Article({ news, totalRecord, currentPage, searchQuery, banner }) {
	const router = useRouter()
	const { pinPost } = newsServices.usePinPost()

	const handlePageChange = (p) => {
		router.push({
			pathname: router.pathname,
			query: {
				page_index: p,
			},
		})
	}

	return (
		<div className="article__page">
			<SEO data={{ title: `Tin tức | ${BASE_CONFIG.SLOGAN}`, url: BASE_CONFIG.PAGE_URL+useRouter().asPath , description: 'Cập nhật những tin tức mới nhất từ 247Express với thông tin dịch vụ và các cập nhật quan trọng trong lĩnh vực vận chuyển. Theo dõi ngay để không bỏ lỡ!'}} />
			<div className="container">
				{!searchQuery ? (
					<div className="article__page-banner">
						<Link href={banner?.Link}>
							{/* eslint-disable-next-line @next/next/no-img-element */}
							<img
								src={IMAGE_HOST + banner?.Image}
								alt="Tin tức"
							/>
						</Link>
					</div>
				) : (
					<h1 style={{ fontSize: 20, margin: 0 }}>
						Kết quả tìm kiếm cho{' '}
						<span style={{ color: 'var(--my-red)' }}>{`"${searchQuery}"`}</span>{' '}
					</h1>
				)}
				<div className="article__page-news">
					<PostNewsList leftNews={news} hotNews={pinPost} />
				</div>
				<div className="article__page-pagination">
					<Pagination
						onChange={handlePageChange}
						showSizeChanger={false}
						defaultCurrent={currentPage}
						pageSize={6}
						total={totalRecord}
					/>
				</div>
			</div>
		</div>
	)
}

Article.Layout = NewsLayout
export default Article

export const getServerSideProps = async ({ query }) => {
	const { page_index, q } = query
	const response = await newsService.getNews({
		pageIndex: Number(page_index),
		pageSize: 4,
		name: q,
	})
	
	const banner = await commonServices.getImage("banner_tin_tuc")

	return {
		props: {
			news: response.Data,
			banner: banner.Data,
			totalRecord: response.TotalRecord,
			currentPage: Number(page_index) || 1,
			searchQuery: q || null,
		},
	}
}
